
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-78439744&scoped=true!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./roundtableSummaryPlagiarismScore.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./roundtableSummaryPlagiarismScore.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-78439744!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./roundtableSummaryPlagiarismScore.vue"),
  /* scopeId */
  "data-v-78439744",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableSummaryPlagiarismScore.vue
// module id = 1247
// module chunks = 61